import PropTypes from 'prop-types';

export default PropTypes.oneOf(['small', 'default', 'large']);
